import type { FC } from 'react';
import { TableCell, Typography } from '@mui/material';

import { useSurveyList } from 'src/components/survey/SurveyContext/ListContext';
import type { CellProps } from 'src/components/survey/SurveySelectionPage/components/SurveyTableView/types';

import { styles } from './cell.styles';

export const SURVEY_TABLE_NAME_TEST_ID = 'survey-table-name';
const SurveyNameCell: FC<CellProps> = ({ columns, survey }) => {
  const { selectSurvey } = useSurveyList();
  const handleOpenSurvey = () => selectSurvey(survey.id);

  return (
    <TableCell
      sx={styles.cell(columns.name.width)}
      width="10rem"
      data-test-id={SURVEY_TABLE_NAME_TEST_ID}
      component="th"
      scope="row"
    >
      <Typography
        sx={styles.surveyNameLink}
        variant="body1"
        title={survey.name}
        data-test-id={survey.name}
        onClick={handleOpenSurvey}
      >
        {survey.name}
      </Typography>
    </TableCell>
  );
};

export default SurveyNameCell;
